var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toplevel-container"},[_c('div',{staticStyle:{"display":"flex"}},[_vm._l((_vm.rootItems),function(root){return _c('div',_vm._l((root.getChildren()),function(item){return _c('ItemList',{key:item._id,attrs:{"itemID":item._id}})}),1)}),_c('ItemList',{attrs:{"itemID":_vm.defaultList}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }